// extracted by mini-css-extract-plugin
export default {"wrapper":"_n-z","response":"ao-z","error":"bo-z","disabled":"co-z","buttons":"do-z","feedbackQuestionSection":"eo-z","yesNoWrapper":"fo-z"};